<template>
  <article class="epc-card" :class="`epc-card--${color}`" @click="$emit('click')">
    <!-- Banda lateral de acento (mismo patrón que list-items-view) -->
    <div class="epc-card__accent"></div>

    <div class="epc-card__body">
      <!-- Header: icono + título -->
      <header class="epc-card__header">
        <span class="epc-card__icon-wrapper">
          <b-icon :icon="icon" pack="fas" size="is-small" />
        </span>
        <h3 class="epc-card__title">{{ title }}</h3>
      </header>

      <!-- Descripción -->
      <p class="epc-card__desc">{{ description }}</p>

      <!-- Footer: tag + link de acción -->
      <footer class="epc-card__footer">
        <span class="epc-card__tag">{{ tag }}</span>
        <span class="epc-card__action">
          {{ actionLabel }} <b-icon icon="arrow-right" pack="fas" size="is-small" />
        </span>
      </footer>
    </div>
  </article>
</template>

<script>
export default {
  name: 'EpcCard',

  props: {
    title:       { type: String, required: true },
    description: { type: String, default: '' },
    tag:         { type: String, default: '' },
    icon:        { type: String, default: 'layer-group' },
    /** Variante de color del accent + tag. Valores soportados: blue | amber | red. Default: blue. */
    color:       { type: String, default: 'blue' },
    actionLabel: { type: String, default: 'Añadir' },
  },
}
</script>

<style scoped>
/* --- Card corporativa EPC (basada en .nav-item de list-items-view) --- */
.epc-card {
  position: relative;
  display: flex;
  background: #fff;
  border: 1px solid #ADC2EA;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  height: 100%;
}

.epc-card:hover {
  border-color: #5577BB;
  box-shadow: 0 2px 8px rgba(85, 119, 187, 0.15);
  transform: translateY(-1px);
}

.epc-card__accent {
  width: 4px;
  flex-shrink: 0;
  transition: width 0.2s ease;
}

.epc-card:hover .epc-card__accent {
  width: 5px;
}

.epc-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
  min-width: 0;
}

.epc-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.epc-card__icon-wrapper {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
}

.epc-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #385DA5;
  line-height: 1.3;
  margin: 0;
  flex: 1;
  min-width: 0;
}

.epc-card__desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0 0 12px 0;
  flex: 1;
}

.epc-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #E5EBF5;
  flex-wrap: wrap;
}

.epc-card__tag {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 9999px;
  white-space: nowrap;
}

.epc-card__action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  transition: transform 0.2s ease;
}

.epc-card:hover .epc-card__action {
  transform: translateX(2px);
}

/* --- Variantes de color --- */
.epc-card--blue .epc-card__accent {
  background: linear-gradient(180deg, #5577BB, #385DA5);
}
.epc-card--blue .epc-card__icon-wrapper {
  background: #EFF4FB;
  color: #5577BB;
}
.epc-card--blue .epc-card__tag {
  background: #EFF4FB;
  color: #385DA5;
}
.epc-card--blue .epc-card__action {
  color: #5577BB;
}

.epc-card--amber .epc-card__accent {
  background: linear-gradient(180deg, #F59E0B, #D97706);
}
.epc-card--amber .epc-card__icon-wrapper {
  background: #FEF3C7;
  color: #D97706;
}
.epc-card--amber .epc-card__tag {
  background: #FEF3C7;
  color: #92400E;
}
.epc-card--amber .epc-card__action {
  color: #D97706;
}

.epc-card--red .epc-card__accent {
  background: linear-gradient(180deg, #EF4444, #DC2626);
}
.epc-card--red .epc-card__icon-wrapper {
  background: #FEE2E2;
  color: #DC2626;
}
.epc-card--red .epc-card__tag {
  background: #FEE2E2;
  color: #991B1B;
}
.epc-card--red .epc-card__action {
  color: #DC2626;
}
</style>
